
import { useSearchActions, useSearchState } from '../../stores/search'

import { PositionResult } from '@/services/SearchV2Service'

const PositionCard = () => {

  const { searchResult } = useSearchState()
  const {  setQuerySearch, fetchQueryResult } =
    useSearchActions()
  // 类型断言确保 searchResult 是 PalletResult 类型
  const positionResult = searchResult as PositionResult


  // 处理托盘点击事件
  const handlePalletClick = (palletCode: string) => {
    // 这里可以添加跳转到托盘详情页面或其他操作
    setQuerySearch(palletCode)
    fetchQueryResult()
  }

  return (
    <>
      <div className="divide-y divide-dashed divide-gray-300">

        {positionResult && (
          <div className="flex justify-between py-3 border-b border-gray-100">
            <span className="text-sm font-medium text-gray-600">区域名称</span>
            <span className="text-sm font-semibold text-gray-900">
              {positionResult.name}
            </span>
          </div>
          
        )}
            <div className="flex justify-between py-3 border-b border-gray-100">
              <span className="text-sm font-medium text-gray-600">总箱数</span>
              <span className="text-sm font-semibold text-gray-900">
                {positionResult.quantity}
              </span>
            </div>
        {/* 托盘列表 */}
        {positionResult.pallets && positionResult.pallets.length > 0 && (
          <div className="">
            <div className="flex justify-between py-3 ">
              <span className="text-sm font-medium text-gray-600">
                托盘详情
              </span>
              <span className="text-sm font-semibold text-gray-900">
                {positionResult.pallets.length} 
              </span>
            </div>
            {positionResult.pallets.map((pallet, index) => (
              <div
                key={index}
                className="ml-4 space-y-2 border-l-2 border-gray-200 pl-4 mb-4 divide-y divide-dashed divide-gray-300"
              >
                <div className="flex justify-between py-2">
                  <span className="text-sm font-medium text-gray-600">
                    托盘编号
                  </span>
                  <span
                    className="text-sm font-semibold text-blue-600 hover:text-blue-800 cursor-pointer underline"
                    onClick={() => handlePalletClick(pallet.palletCode)}
                  >
                    {pallet.palletCode}
                  </span>
                </div>
                <div className="flex justify-between py-2">
                  <span className="text-sm font-medium text-gray-600">
                    状态
                  </span>
                  <span className="text-sm font-semibold text-gray-900">
                    {pallet.statusDisplay}
                  </span>
                </div>
                <div className="flex justify-between py-2">
                  <span className="text-sm font-medium text-gray-600">
                    箱货数量
                  </span>
                  <span className="text-sm font-semibold text-gray-900">
                    {pallet.quantity}
                  </span>
                </div>
                {/* {pallet.entry_date && (
                  <div className="flex justify-between py-2">
                    <span className="text-sm font-medium text-gray-600">
                      入库时间
                    </span>
                    <span className="text-sm font-semibold text-gray-900">
                      {new Date(pallet.entry_date).toLocaleDateString()}
                    </span>
                  </div>
                )} */}
              </div>
            ))}
          </div>
        )}
      </div>
    </>
  )
}

export default PositionCard
